/** @jsx builderX.jsx */

import { builderX, Sprite, Image, Button } from '@gongxigames/framework/core/fragments/BuilderX';

export default (
    <Sprite name='balanceBar'>
        <Button position={[32, 741]} hitArea={{ width: 325, x: 0, y: 0, type: 'rectangle', height: 291 }} name='plusButton'>
            <Sprite>
                <Image src='plus_button_normal' />
            </Sprite>
            <Sprite>
                <Image src='plus_button_normal' />
            </Sprite>
            <Sprite>
                <Image src='plus_button_pressed' />
            </Sprite>
            <Sprite>
                <Image src='plus_button_disabled' />
            </Sprite>
        </Button>
        <Button position={[32, 1032]} hitArea={{ width: 325, x: 0, y: 0, type: 'rectangle', height: 291 }} name='minusButton'>
            <Sprite>
                <Image src='minus_button_normal' />
            </Sprite>
            <Sprite>
                <Image src='minus_button_normal' />
            </Sprite>
            <Sprite>
                <Image src='minus_button_pressed' />
            </Sprite>
            <Sprite>
                <Image src='minus_button_disabled' />
            </Sprite>
        </Button>
    </Sprite>
);
